import { configureStore } from '@reduxjs/toolkit';
import { connectRouter, routerMiddleware } from 'connected-react-router';

import history from '../history';
import scanSession from './scanSession';

const store = configureStore({
	reducer: { scanSession: scanSession.reducer, router: connectRouter(history) },
	middleware: (getDefaultMiddleware) => [
		routerMiddleware(history),
		...getDefaultMiddleware(),
	],
});

export default store;
